import { Injectable } from '@angular/core';
import {
  UrlTree,
  Router,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    return this.check(route.data);
  }

  /**
   * canLoad only runs before a lazy `loadChildren` is fetched, so it never
   * fires for routes declared with `component:`. Pages that carry their own
   * permission must list this guard in canActivate to have it enforced.
   */
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (
      route.paramMap.get('id') === 'new' &&
      route.data?.permission?.createAccessOnly
    ) {
      return this.check({
        ...route.data,
        permission: {
          ...route.data.permission,
          accessOnly: route.data.permission.createAccessOnly
        }
      });
    }
    return this.check(route.data);
  }

  private check(data: any): boolean | UrlTree {
    let access = true;
    const redirectUrl = data?.permission?.redirectTo || '/unauthorized';
    const privilege = data?.permission?.accessOnly;
    if (this.authService.isAuthenticated()) {
      if (!this.authService.isAdmin()) {
        if (privilege) {
          access = this.authService.isPermission(privilege);
        }
        if (!access) {
          return this.router.parseUrl(redirectUrl);
        }
      }
    } else {
      return this.router.parseUrl('/login');
    }
    return access;
  }
}
